"use client";

import ServicesPage from "../pages/manage/ServicesPage";

export default function Manage() {
  return <ServicesPage />;
}
